import store, { RootState } from '@/store/store';
import { ApiState } from '../store/types/general.types';
import { AuthApiState } from '../store/modules/auth/types/auth.types';
import { DocumentsApiState } from '../store/modules/documents/types/documents.types';
import { partial as _partial } from 'lodash';
import { DispatchOptions } from 'vuex';
import Vue from 'vue';

export const useStore = function (this: Vue) {
  return this.$store;
};
export const useRootState = function (vue?: Vue | void) {
  if (vue) {
    console.warn(
      'this function does not need a reference to a vue instance in order to access the store'
    );
  }
  return (vue ? vue.$store.state : store.state) as RootState;
};
export const useAuthState = function (this: Vue | void) {
  return useRootState.call(this).auth;
};
export const useDocumentsState = function (this: Vue | void) {
  return useRootState.call(this).documents;
};
export const useProjectsState = function (this: Vue | void) {
  return useRootState.call(this).projects;
};
export const useWebsocketState = function (this: Vue | void) {
  return useRootState.call(this).websocket;
};
export const useUsersState = function (this: Vue | void) {
  return useRootState.call(this).users;
};

type AllApiState = AuthApiState | DocumentsApiState;

const splitNamespacedAction = (namespacedAction: string) => {
  const [moduleName, actionName] = namespacedAction.trim().split('/') as [
    keyof Omit<RootState, 'websocket'>,
    keyof AllApiState
  ];
  return { moduleName, actionName };
};

export const useApiState = function (this: Vue, namespacedAction: string) {
  const { moduleName, actionName } = splitNamespacedAction(namespacedAction);
  try {
    return (store.state[moduleName].apiState as AllApiState)[
      actionName
    ] as ApiState;
  } catch (error) {
    return undefined;
  }
};

/**
 * @deprecated This function is deprecated and will be removed in future versions.
 * Use `useActionExt()` instead.
 */
export const useAction = function (this: Vue, namespacedAction: string) {
  console.warn(
    'this function does not need a reference to a vue instance, use "useActionExt" instead'
  );

  return _partial(store.dispatch, namespacedAction as any) as (
    payload?: any,
    options?: DispatchOptions
  ) => Promise<any>;
};

export const useActionExt = function <T = any>(namespacedAction: string) {
  return _partial(store.dispatch, namespacedAction as any) as (
    payload?: T,
    options?: DispatchOptions
  ) => Promise<any>;
};

export const useGetter = function (this: Vue, namespacedGetter: string) {
  return useStore.call(this).getters[namespacedGetter];
};
